export default __webpack_public_path__ + "applications.html";